import { CargoTempListItem, CargoTempListItemWrapper } from './CargoTempDateListComponent.style';
import { CargoTemperatureLogDate } from '../../../types/ViewModel/CargoTempLog/CargoTemperatureLogDate';
import { CargoTemperatureConfig } from '../../../types/ViewModel/CargoTempLog/CargoTemperatureConfig';
import { DateTimeFormat, formatDateTime, prettifyDate } from 'odfjell-date-time-utils/dateTimeFormatter';
import { CargoTempLogStatusEnum } from '../../../enums/cargoTempLogEnum';
import CargoTempLogStatusIcon from '../../ui/status-icon/CargoTempLogStatusIcon';

type Props = {
    populatedCargoTempLogDates: CargoTemperatureLogDate[];
    cargoTemperatureConfigs: CargoTemperatureConfig[];
    cargoTempLogDate: CargoTemperatureLogDate;
    onSelectCargoTempDate: (date: Date) => void;
    isSelectedListItem: (date: Date) => boolean;
};

const CargoTempDateListItem: React.FC<Props> = (props: Props) => {
    const cargo = props.cargoTempLogDate.cargoInTankList?.map((c) => c.cargoNumber);
    const allCargoConfigured =
        cargo && cargo.length > 0 && cargo.every((c) => !!props.cargoTemperatureConfigs?.find((conf) => conf.cargoNumber === c));
    const hasDayCargo = cargo && cargo.length > 0;

    return (
        <CargoTempListItemWrapper
            onClick={() => props.onSelectCargoTempDate(props.cargoTempLogDate.logDate)}
            key={'cargo_list_date ' + formatDateTime(props.cargoTempLogDate.logDate, DateTimeFormat.queryFormats.dateOnly)}
        >
            <div className="aol-item">
                <CargoTempListItem isSelected={props.isSelectedListItem(props.cargoTempLogDate.logDate)} isValid={true}>
                    <div className="upper-wrapper">
                        <span>{prettifyDate(props.cargoTempLogDate.logDate)}</span>
                        <span className="icons-wrapper">
                            <span className="icon-wrapper">
                                {allCargoConfigured
                                    ? CargoTempLogStatusIcon(
                                          props.cargoTempLogDate?.isComplete ? CargoTempLogStatusEnum.complete : CargoTempLogStatusEnum.incomplete
                                      )
                                    : CargoTempLogStatusIcon(hasDayCargo ? CargoTempLogStatusEnum.configMissing : CargoTempLogStatusEnum.noCargo)}
                            </span>
                        </span>
                    </div>
                    <div className="lower-wrapper"></div>
                </CargoTempListItem>
            </div>
        </CargoTempListItemWrapper>
    );
};

export default CargoTempDateListItem;
